<script>
  import GoalOption from "../Components/Goals/GoalOption.svelte";
  import { clickForGoalSettings } from "../static";
  import { External, M } from '../../external';

  export let add = ignore, extraGoals = [];

  let cmps = [];

  let goalOptions = [
    ...extraGoals, // ABANDONED_CART_RECOVER for example
    "LIST_ADD",
    "MEMBER_GROUP_ADD",
    //"MEMBER_GROUP_REMOVE",
    "TAG_ADD",
    "PROPERTY_CHANGE",
    "EMAIL_OPEN",
    "EMAIL_CLICK",
    "PURCHASE_MAKE",
    "PAGE_VISIT",
    ...(External.Website.videoFeaturesDisabled ? [] : [
      "VIDEO_STARTED",
      "VIDEO_COMPLETED"
    ])
  ];

  const onClick = (type) => {
    clickForGoalSettings(type, null, add);
  };

  $: cmps = cmps.filter((el) => el);
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-25 mb-10">{M.AUTOMATION_GOALS}</h4>
  <ul>
    {#each goalOptions as option, index (option)}
      <GoalOption bind:this={cmps[index]} onClick={() => onClick(option)} bind:type={option} />
    {/each}
  </ul>
</div>
